import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-slider-dialog',
  templateUrl: './slider-dialog.component.html',
  styleUrls: ['./slider-dialog.component.scss']
})
export class SliderDialogComponent implements OnInit {
  public form: FormGroup;
  constructor(public dialogRef: MatDialogRef<SliderDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public fb: FormBuilder) { }

  ngOnInit(): void { 
    this.form = this.fb.group({
      id:0,
      title: null,
      subtitle: null,
      link: null,
      image: null,
      sortNumber: null
    }); 

    if(this.data.slider){
      if(this.data.slider.image[0].preview){
        this.form.patchValue(this.data.slider);
      }else{
        this.getBase64ImageFromUrl(this.data.slider.image).then(res => {
          this.data.slider.image=[{link:"slider", preview:res}]
          this.form.patchValue(this.data.slider);
        })
      }
    };
  }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader  = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  public onSubmit(){
    if(this.form.valid){
      this.dialogRef.close(this.form.value);
    }
  }

}
